module.exports = __webpack_public_path__ + "img/shipo-map-eta.3d3d7da8.svg";